<template>
  <div>
    <div>
      <router-link to="/">Home</router-link>
      <label class="labelBar"> / </label>
      <router-link to="/condicaoPagamento">
        Cadastro/Produtos e Serviços
      </router-link>
      <label class="labelBar"> / Condição Pagamento</label>
      <label v-if="!readOnly"> Editar</label>
      <label v-else> Ver</label>
    </div>
    <tab-navegacao />
    <v-container fluid>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row align="center">
          <v-col>
            <v-text-field
              label="Descrição *"
              v-model="descricao"
              v-uppercase
              :counter="200"
              :rules="[(v) => !!v || 'A Descrição é obrigatória']"
              :readonly="readOnly"
              required
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
      <v-row align="center-left">
        <v-col cols="12" sm="6">
          <v-checkbox
            v-model="condicao.ativo"
            @click.native.stop.prevent="checkAssociacao()"
            label="Ativo"
            :readonly="readOnly"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" sm="6" class="text-right">
          <v-btn to="/condicaoPagamento" color="error" class="mr-4" v-if="!readOnly">
            Voltar
          </v-btn>
          <v-btn to="/condicaoPagamento" color="success" class="mr-4" v-else>
            Voltar
          </v-btn>
          <v-btn @click="enviar" color="success" class="mr-4" v-if="!readOnly">
            Salvar
          </v-btn>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
  </div>
</template>

<script>
import { editarCondicaoPagamentoAsync } from "../../../services/condicaoPagamentoService";
import { mapState, mapActions } from "vuex";
import TabNavegacaoProduto from "../../Tabs/TabCadastroProduto";
import { getUserPermission } from "@/services/loginService";

export default {
  name: "editarCondicaoPagamento",
  data: () => ({
    overlay: false,
    valid: true,
    descricao: null,
    readOnly: false,
  }),
  computed: {
    ...mapState("condicaoPagamento", ["condicao"]),
    //...mapState("usuario", ["usuarios"]),
  },
  methods: {
    //...mapActions("usuario", ["atualizarUsuarios"]),
    async enviar() {
      if (this.$refs.form.validate()) {
        this.overlay = true;
        const resposta = await editarCondicaoPagamentoAsync(
          this.condicao.id,
          this.descricao,
          this.condicao.ativo
        );
        if (
          resposta == null ||
          (resposta.status != null && resposta.status != 200)
        ) {
          this.overlay = false;
          this.$alert(resposta.message, "Descupe, falha na operação!", "error");
        } else {
          this.overlay = false;
          this.$store.dispatch("ui/showSnackbar", {
            text: "Atualizado com sucesso!",
            color: "success",
            timeout: 3000,
          });
          this.$router.push("/condicaoPagamento");
        }
      }
    },
    /*checkAssociacao: async function () {
      if (!this.cargo.ativo) {
        if (!this.usuarios || this.usuarios.length == 0) {
          this.overlay = true;
          await this.atualizarUsuarios();
          this.overlay = false;
        }
        var usuarios = this.findUsuario(this.departamento.id);
        if (usuarios != null && usuarios.length > 0) {
          this.$alert(
            "O(s) usuário(s) '" +
              usuarios.map((e) => e.nome).join("', '") +
              "' estão ativos e associados a esse departamento.",
            "Ação não permitida!",
            "error"
          );
          this.departamento.ativo = !this.departamento.ativo;
        }
      }
    },*/
  },
  created: function () {
    this.readOnly = !getUserPermission(6);
    this.descricao = this.condicao.descricao;
  },
  components: {
    TabNavegacaoProduto,
  },
};
</script>
